<template>
  <div>
    <v-container fluid>
      <p>Start a conversation with the affiliate:</p>
      <affiliate-list ref="affiliateListRef" :affiliates="this.getAffiliatesChat.data" @switch-affiliate="switchAffiliate"></affiliate-list>
      <v-text-field v-model="newMessage" label="Type your message"></v-text-field>
      <v-btn @click="createThread" color="primary" :disabled="!newMessage.trim()">Send</v-btn>
      <v-col cols="6" md="6">
        <v-text-field
          v-model="inputValue"
          aria-placeholder="Search"
          append-icon="mdi-magnify"
          @click:append="onSearch"
          @keydown.enter="onSearch"
          @input="onSearch"
        ></v-text-field>
      </v-col>
      <message-list v-if="filteredMessages.length" :messages="filteredMessages" @select-message="selectThread"></message-list>
    </v-container>
  </div>
</template>

<script>
import {debounce} from "debounce";
import MessageList from './MessageList.vue';
import AffiliateList from './AffiliateList.vue';
import {mapState, mapGetters, mapMutations, mapActions} from 'vuex';
import store from "@/store";

export default {
  props: {
    item: {
      type: Object,
    },
  },
  components: {
    MessageList,
    AffiliateList
  },
  data() {
    return {
      selectedAffiliateId: null,
      newMessage: "",
      managerId:null,
      lastKey: null,
      leftValue: 765,
      filteredMessages: [],
      inputValue: "",
    };
  },
  beforeDestroy() {
    this.UNSUBSCRIBE_FROM_MESSAGES()
    this.UNSUBSCRIBE_FROM_READ_STATUS()
  },
  methods: {
    ...mapMutations('messages', ['setNewThreadMessages','clearNewThreadMessages', 'setSelectedThread']),
    ...mapActions('messages', ['FETCH_THREAD_MESSAGES','UNSUBSCRIBE_FROM_MESSAGES','UNSUBSCRIBE_FROM_READ_STATUS']),
    switchAffiliate(affiliateId) {
      this.selectedAffiliateId = affiliateId;
    },
    showChatMessagesCard(item) {

      const currentKey = `chatMessages-${item.id}`;
      const existingCard = this.getCards.find((card) => card.key === currentKey);
      store.dispatch('cards/REMOVE', currentKey)
      // if (this.leftValue > 1000){
      //   this.leftValue = 765;
      // }
      // if (this.lastKey && this.lastKey !== currentKey) {
      //   this.leftValue += 10;
      // }

      const latestMessage = item.messages.reduce((prev, current) => {
        return (prev.date_added > current.date_added) ? prev : current;
      });

      const lastMessageText = latestMessage.message.substring(0, 20);

      store.dispatch('cards/ADD', {
        type: 'chatMessages',
        title: `${item.affiliate_name} ${lastMessageText}`,
        key: currentKey,
        data: item,
        customSize: {
          width: 717,
          height: 824,
          top: 45,
          left: this.leftValue,
        },
      })
      this.lastKey = currentKey;
      // if (existingCard){
      //   // this.$store.dispatch('cards/SET_ACTIVE', currentKey);
      //   // this.$store.dispatch('cards/REMOVE', currentKey)
      // } else {
      //   if (this.leftValue > 1000){
      //     this.leftValue = 765;
      //   }
      //   if (this.lastKey && this.lastKey !== currentKey) {
      //     this.leftValue += 10;
      //   }
      //
      //   store.dispatch('cards/ADD', {
      //     type: 'chatMessages',
      //     title: item.affiliate_name,
      //     key: currentKey,
      //     data: item,
      //     customSize: {
      //       width: 717,
      //       height: 824,
      //       top: 45,
      //       left: this.leftValue,
      //     },
      //   })
      //
      // }
      // this.lastKey = currentKey;
    },
    async createThread() {
      if (!this.newMessage) return
      try {
        const senderId = this.managerId
        const params = {
          senderId: senderId,
          senderType: 'manager',
          recipientId:this.selectedAffiliateId,
          recipientType: 'affiliate',
          message: this.newMessage,
          employeeId: this.user[0].employee_id,
        }
        await store.dispatch('messages/CREATE_THREAD', params);
        this.newMessage = "";
      } catch (e) {
        console.log('createThread error:', e);
      }


    },
    async selectThread(message) {
      this.setSelectedThread({ ...message });
      // console.log(`[SELECTED_THREAD_WITH_MESSAGES] ${JSON.stringify(this.getSelectedThread)}`);
      await this.FETCH_THREAD_MESSAGES()
      this.showChatMessagesCard(this.getSelectedThread);
    },

    onSearch: debounce(function () {
      if (!this.inputValue) {
        this.filteredMessages = [...this.getThreadMessages];
        return;
      }
      this.filteredMessages = this.filteredMessages
              .filter(message => {
                console.log(message['contact_user_type'], message['affiliate_id'], Number(this.inputValue), this.inputValue)
                return message['author_name'].toLowerCase().includes(this.inputValue.toLowerCase())
                || (message['contact_user_type'] === 'affiliate' && !isNaN(Number(this.inputValue)) && message['affiliate_id'] === Number(this.inputValue))
                || (message['contact_user_type'] === 'advertiser' && !isNaN(Number(this.inputValue)) && message['advertiser_id'] === Number(this.inputValue))
              });
    }, 700)

  },
  async mounted() {
    if (!this.user[0].employee_id) {
      await this.$router.push('/403');
    }
    const affiliateManager = this.affiliateManagers.find(item => item.email === this.user[0].email);
    this.managerId = affiliateManager.id;
    const filters ={
      search: "",
      affiliateV2: "V2",
    }
    await store.dispatch('affiliates/getAffiliatesChat', {
      payload: {
        limit: 25,
        page: 1,
        orderBy: '',
        orderDirectionAsc: false,
        filters: filters || null
      }
    })

    await store.dispatch('managers/saveAffiliatesByManager', this.managerId);
    await store.dispatch('messages/FETCH_MESSAGES');

    this.filteredMessages = [...this.getThreadMessages];

  },
  computed: {
    ...mapState('user', ['user']),
    ...mapState('messages', ['messages']),
    ...mapGetters('messages', ['getThreadMessages','getSelectedThread']),
    ...mapGetters('managers', ['affiliatesByManager']),
    ...mapGetters('cards', ['getCards']),
    ...mapState('managers', ['affiliateManagers']),
    ...mapGetters('affiliates', ['getSflAffiliates_','getAffiliatesChat'])

  },
};
</script>

<style scoped>
/* Your scoped styles */
</style>
